import React from "react";
import { Text, StyleSheet, View, BackHandler, Linking } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { Screen, Button, ButtonVariant } from "../../components";
import { translate } from "../../i18n";
import { useFonts } from "expo-font";

export const NoNetworkStack = () => {
  const navigation = useNavigation();
  navigation.setOptions({
    title: `No Internet Connection`,
  });
  return (
    <Screen style={style.container}>
      <View style={{ flex: 6, alignItems: "center", justifyContent: "center" }}>
        <Text style={{ ...style.commonText, ...style.title }}>
          {translate("noNetworkStack.connectionErrorTitle")}
        </Text>
        <Text style={{ ...style.commonText, ...style.message }}>
          {translate("noNetworkStack.connectionErrorMessage")}
        </Text>
      </View>
    </Screen>
  );
};

const style = StyleSheet.create({
  commonText: {
    color: "#666666",
    fontSize: 16,
    lineHeight: 24,
    textAlign: "center",
  },
  container: {
    backgroundColor: "#fff",
    flex: 1,
    justifyContent: "center",
  },
  title: {
    color: "#D81620",
    fontSize: 32,
    fontWeight: "700",
    lineHeight: 48,
    paddingBottom: 8,
  },
  message: {},
  later: {
    fontWeight: "700",
  },
});
